<div style="display: flex; flex-direction: column; height: 100%">
  <div style="display: flex; justify-content: center">
    <h2 mat-dialog-title>Feedback</h2>
  </div>
  <mat-dialog-content style="flex: 1">
    <form [formGroup]="feedbackForm" style="height: 100%">
      <!-- <mat-form-field>
        <input matInput placeholder="First Name" formControlName="firstName">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Last Name" formControlName="lastName">
      </mat-form-field>
      <mat-form-field>
        <input matInput type="email" placeholder="Email Address" formControlName="emailAddress">
      </mat-form-field> -->
      <mat-form-field style="height: 100%">
        <textarea matInput name="webhookHeader" style="height: 100%" placeholder="Content" formControlName="content"></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions style="display: flex">
    <button mat-raised-button color="primary" mat-dialog-close>Cancel</button>
    <div style="flex: 1"></div>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button color="primary" (click)="sendEmail()" [disabled]="!feedbackForm.valid || !feedbackForm.dirty">Send</button>
  </mat-dialog-actions>
</div>
